export const FETCH_OPTIONS = 'FETCH_OPTIONS';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_AUTH_INFO = 'UPDATE_AUTH_INFO';
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN';

export const UPDATE_SELECTED_LANGUAGE = 'UPDATE_SELECTED_LANGUAGE';

export const FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';

export const FETCH_REGISTER_ITEMS = 'FETCH_REGISTER_ITEMS';
export const FETCH_REGISTER_ITEM = 'FETCH_REGISTER_ITEM';
export const CREATE_REGISTER_ITEM = 'CREATE_REGISTER_ITEM';
export const UPDATE_REGISTER_ITEM = 'UPDATE_REGISTER_ITEM';
export const DELETE_REGISTER_ITEM = 'DELETE_REGISTER_ITEM';
export const CLONE_REGISTER_ITEM = 'CLONE_REGISTER_ITEM';
